// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1JNe1","tab":"Tabs_tab__1XWBQ","tabActive":"Tabs_tabActive__FFD6R"};